<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	What information was incorrect ?
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="!utilService.isNullOrUndefined(incorrectDataTypeSelected)"
		fxLayout="row"
		fxLayoutGap="1rem"
	>
		<div
			*ngFor="let question of ( incorrectDataTypeSelected == incorrectDataTypes[0] ) ?
			incorrectLaneInfoQuestions : incorrectContactInfoQuestions"
			fxFlex
		>
			<mat-radio-group [(ngModel)]="answerSelected">
				<mat-radio-button
					(click)="setSelection(question, 'answerSelected')"
					[value]="question"
					color="primary"
					fxFlex="100"
				>
					{{question}}
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>

	<mat-divider style="margin: 1rem 0"></mat-divider>

	<div fxLayout="row">
		<div fxFlex>
			<quill-editor
				[formControl]="notes"
				[modules]="{toolbar: false}"
				format="text"
				placeholder="Extra notes..."
				class="full-width"
			></quill-editor>
		</div>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxFlex="100" fxLayoutAlign="end end">
		<button
			(click)="submit()"
			[disabled]="allQuestionsAnswered()"
			color="primary"
			mat-raised-button
		>
			Done
		</button>
		<a (click)="closeDialog()" mat-button style="color: blue">
			<u>Close</u>
		</a>
	</div>
</mat-dialog-actions>
